export const FOOTER_LEGAL_SECTION = {
  title: 'Legal',
  links: [
    { name: 'Privacy Policy', type: 'event', target: 'privacy-policy' },
    { name: 'Terms of Service', type: 'event', target: 'terms-of-service' },
    { name: 'Refund Policy', type: 'event', target: 'refund-policy' },
    { name: 'Cookie Policy', type: 'event', target: 'cookie-policy' }
  ]
};

export const FOOTER_BOTTOM_LINKS_CONTENT = [
  { name: 'Privacy', type: 'event', target: 'privacy' },
  { name: 'Terms', type: 'event', target: 'terms' },
  { name: 'Refunds', type: 'event', target: 'refunds' }
];

export const FOOTER_COPYRIGHT_SUFFIX_CONTENT = 'All rights reserved. Made with ❤️ for spiritual journeys.';
